module.exports = __webpack_public_path__ + "Banner_MedicalTips-a5feb8fc12db8490267c110b7d3d439b.svg";